import { ThemeOptions } from '@mui/material/styles'

// Shared typography across all themes
export const typography = {
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
  ].join(','),
  h1: {
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1.2,
  },
  h2: {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.3,
  },
  h3: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  button: {
    textTransform: 'none' as const,
    fontWeight: 500,
  },
}

// Shared breakpoints
export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
}

// Shared component overrides
export const components: ThemeOptions['components'] = {
  MuiAvatar: {
    styleOverrides: {
      root: {
        '& img': {
          objectFit: 'cover',
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: 8,
        padding: '8px 16px',
        // Touch target: a 32px button is a miss on a phone.
        [theme.breakpoints.down('sm')]: {
          minHeight: 40,
        },
      }),
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        [theme.breakpoints.down('sm')]: {
          minWidth: 40,
          minHeight: 40,
        },
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }) => ({
        // Default cell padding (16px each side) is what pushes tables off the right edge of a
        // 390px screen. Tighten it below sm; desktop is untouched.
        [theme.breakpoints.down('sm')]: {
          padding: '8px 10px',
          fontSize: '0.8125rem',
        },
      }),
      sizeSmall: ({ theme }) => ({
        [theme.breakpoints.down('sm')]: {
          padding: '6px 8px',
        },
      }),
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 12,
      },
    },
  },
  MuiTextField: {
    defaultProps: {
      variant: 'outlined',
    },
  },
}
